module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House47.75353058.jpg";